/* Elora rows: reveal the heat readout and the "use it while" strip (.is-in) once they are on screen.
   Row videos are lazy-loaded and played by assets/elora-video.js. Re-runs for a section the Theme Editor re-renders,
   and lets go of a section it unloads. */
(function () {
  var SEL = '[data-hb], [data-hscale], [data-uses]';
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { threshold: 0.4 })
    : null;
  function init(scope) {
    var items = [].slice.call((scope || document).querySelectorAll(SEL)).filter(function (s) {
      if (s.hasAttribute('data-elora-rows-ready')) return false;
      s.setAttribute('data-elora-rows-ready', '');
      return true;
    });
    if (!io) { items.forEach(function (s) { s.classList.add('is-in'); }); return; }
    items.forEach(function (s) { io.observe(s); });
  }
  function drop(scope) {
    if (!io || !scope || !scope.querySelectorAll) return;
    [].slice.call(scope.querySelectorAll(SEL)).forEach(function (s) { io.unobserve(s); s.removeAttribute('data-elora-rows-ready'); });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
  document.addEventListener('shopify:section:unload', function (e) { drop(e.target); });
})();
